import type { PriceAnomalyRuleSnapshot } from "../api/priceAnomalyRule";

export const DEFAULT_PRICE_ANOMALY_RULE: PriceAnomalyRuleSnapshot = {
  revision: 0,
  comparison_basis: "prior_12m_fallback",
  threshold_pct: "15",
  minimum_overpay_abs: null,
  minimum_reference_count: 2,
  updated_at: null,
};

export function priceAnomalyRuleText(
  rule: PriceAnomalyRuleSnapshot = DEFAULT_PRICE_ANOMALY_RULE,
): string {
  const threshold = formatRuleNumber(rule.threshold_pct);
  const minimum = rule.minimum_overpay_abs
    ? ` und die Mehrkosten mindestens ${formatRuleNumber(rule.minimum_overpay_abs)} in der Belegwährung betragen`
    : "";
  return `Eine Position geht in die Preisprüfung, wenn ihr Netto-Einheitspreis mindestens ${threshold} % über der Preisreferenz zum Belegdatum liegt${minimum}. ${basisSentence(rule.comparison_basis)} ${rule.minimum_reference_count >= 2 ? `Mindestens ${rule.minimum_reference_count} frühere Positionen aus mindestens 2 Belegen sind nötig. Vergleiche mit weniger Daten bleiben separat sichtbar.` : "Für diesen Datenstand genügt ein früherer Vergleichspreis."}`;
}

export const PRICE_ANOMALY_RULE_TEXT = priceAnomalyRuleText();

function basisSentence(
  basis: PriceAnomalyRuleSnapshot["comparison_basis"],
): string {
  if (basis === "prior_all_history") {
    return "Es zählt die gesamte frühere Historie desselben Artikels.";
  }
  if (basis === "prior_24m_fallback") {
    return "Es zählen nur frühere Preise desselben Artikels: zuerst 24 Monate, danach die gesamte frühere Historie.";
  }
  return "Es zählen nur frühere Preise desselben Artikels: zuerst 12 Monate, sonst 24 Monate, danach die gesamte frühere Historie.";
}

function formatRuleNumber(value: string): string {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return value;
  return parsed.toLocaleString("de-AT", { maximumFractionDigits: 3 });
}
